import { Link } from 'react-router-dom'
import { KTSVG } from '_metronic/helpers'

interface Props {
  title: string
  icon: string
  path?: string
  onClick?: () => void
  color?: string
  textColor?: string
}

const MenuBox: React.FC<Props> = ({
  title,
  path,
  icon,
  onClick,
  color = 'primary',
  textColor = 'white',
}) => {
  return (
    <Link to={path ?? '#'} onClick={() => (onClick ? onClick() : {})}>
      <div
        className={`p-4 text-${textColor} btn btn-lg btn-${color} d-flex flex-column align-items-start shadow border`}>
        <span className='fs-2 px-2 fw-bold'>{title}</span>
        <span className='menu-icon'>
          <KTSVG path={icon} className='svg-icon-1 home-shortcut' />
        </span>
      </div>
    </Link>
  )
}

export default MenuBox
